import { createUseStyles } from 'react-jss';
import { color, fontSize, spacing } from '@blink/components';

export const useManageDetailsStyle = createUseStyles({
    top: {
        display: 'flex',
        padding: `${spacing['08']} 10% ${spacing['10']}`,
        flexDirection: 'column',
        alignItems: 'flex-start',
        alignSelf: 'stretch',
    },
    breadcrumbs: {
        display: 'flex',
        alignItems: 'center',
        margin: `${spacing['05']} 0`,
        color: color.content.secondary,
        fontSize: fontSize.lg,
        gap: spacing['03'],
    },
    topTitle: {
        display: 'flex',
        padding: `0 10%`,
        flexDirection: 'column',
        alignItems: 'flex-start',
        alignSelf: 'stretch',
    },
    heading: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        alignSelf: 'stretch',
    },
    title: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        gap: spacing['02'],
    },
    titleText: {
        display: 'flex',
        color: color.content.primary,
        fontSize: '32px',
        fontWeight: 600,
        lineHeight: '40px',
        letterSpacing: '-0.64px',
    },
    loader: {
        display: 'flex',
        width: '100%',
        height: 300,
        alignItems: 'center',
        justifyContent: 'center',
    },
    blur: {
        width: '100%',
        height: '100%',
        filter: 'blur(3px)',
        pointerEvents: 'none',
    },
    vaultActivationInProgressModalWrapper: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
    },
});
